import actions from "./actions";

const initState = {
    createGroupState: null,
    createGroupResult: null,
    readGroupListState: null,
    groups: [],
    readGroupState: null,
    group: {
        id: undefined,
        name: undefined,
        contact_ids: [],
    },
    selectedContactIds: [],
    allContactIds: [],
    updateGroupState: null,
    deleteGroupState: null,
};

function reorderAllContactIds(allContactIds, selectedContactIds) {
    const selected = [];
    const unselected = [];

    allContactIds.forEach(id => {
        if (selectedContactIds.find(c => c === id))
            selected.push(id);
        else
            unselected.push(id);
    });

    return [...selected, ...unselected];
}

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.CONTACT_GROUP_CREATE_REQUEST:
            return {
                ...state,
                createGroupState: 'request',
            };
        case actions.CONTACT_GROUP_CREATE_SUCCESS:
            return {
                ...state,
                createGroupState: 'success',
                createGroupResult: action.data,
            };
        case actions.CONTACT_GROUP_READ_LIST_REQUEST:
            return {
                ...state,
                readGroupListState: 'request',
            };
        case actions.CONTACT_GROUP_READ_LIST_SUCCESS:
            return {
                ...state,
                readGroupListState: 'success',
                groups: action.groups,
            };
        case actions.CONTACT_GROUP_READ_REQUEST:
            return {
                ...state,
                readGroupState: 'request',
            };
        case actions.CONTACT_GROUP_READ_SUCCESS:
            return {
                ...state,
                readGroupState: 'success',
                group: action.group,
                selectedContactIds: action.group.contact_ids,
                allContactIds: reorderAllContactIds(state.allContactIds, action.group.contact_ids),
            };
        case actions.CONTACT_GROUP_UPDATE_REQUEST:
            return {
                ...state,
                updateGroupState: 'request',
            };
        case actions.CONTACT_GROUP_UPDATE_SUCCESS:
            return {
                ...state,
                updateGroupState: 'success',
            };
        case actions.CONTACT_GROUP_DELETE_REQUEST:
            return {
                ...state,
                deleteGroupState: 'request',
            };
        case actions.CONTACT_GROUP_DELETE_SUCCESS:
            return {
                ...state,
                deleteGroupState: 'success',
            };
        case actions.CONTACT_GROUP_INIT:
            return {
                ...state,
                group: action.group,
                selectedContactIds: action.group.contact_ids || [],
            };
        case actions.CONTACT_GROUP_SET_CONTACT_IDS:
            return {
                ...state,
                selectedContactIds: action.selectedContactIds,
            };
        case actions.CONTACT_GROUP_SET_ALL_CONTACT_IDS:
            return {
                ...state,
                allContactIds: reorderAllContactIds(action.allContactIds, state.selectedContactIds),
            };
        case actions.CONTACT_GROUP_RESET:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
